
import { Component } from 'react'
import ToastMsg from '../../Components/ToastMsg/ToastMsg';
import {
    Box, Grid, Stack, Paper, Typography, Button, FormControlLabel,
    TextField, Checkbox, Tooltip
} from '@mui/material';
import { ImagePaths } from '../../Utility/ImagePaths';
import RestAPIService from '../../Utility/Services/RestAPIService';
import { Serviceurls } from '../../Utility/API/Serviceurls';
import { Attendercard_Layout_Default_JSON } from '../../Utility/Constants';
import CommonValidation from '../../Components/CommonFunctions/CommonValidation';
import { Colors } from '../../Styles/Colors';
import Loader from '../../Components/Loader'

class AttendercardLayoutConfig extends Component {
    constructor(props) {
        super(props)
        this.state = {
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: '',
            cardWidth: "8",
            cardHeight: "5",
            Label: "true",
            card_detail_data: structuredClone(Attendercard_Layout_Default_JSON.map(item =>
                item.label === "Patient Name"
                    ? { ...item, include_age_gender: false }
                    : item
            )),
            drag_label: null,
            AlignLeft: true,
            AlignCenter: false,
            AlignRight: false,
            AlignTop: true,
            AlignBottom: false,
            AlignMiddle: false,
            Margintop: "0",
            MarginRight: "0",
            MarginBottom: "0",
            MarginLeft: "0",
            FontSize: 10,
            isLoader: false,
            LineSpace: 5,
            previewUrl: "",
        }
    }

    componentDidMount() {
        this.getCardLayout()
    }

    getCardLayout = () => {
        try {
            this.LoaderFunction(true)
            RestAPIService.getAllTwo(Serviceurls.ATTENDER_CARD_CONFIG)
                .then((response) => {
                    if (response.data.status === "success") {
                        var Data = response.data.data
                        const patientNameField = Data?.attender_details?.find(item => item.label === "Patient Name");

                        this.setState({
                            card_detail_data: Data?.attender_details ?
                                Data.attender_details.map(item => {
                                    if (item.label === "Patient Name") {
                                        return {
                                            ...item,
                                            include_age_gender: item.include_age_gender || false
                                        };
                                    }
                                    if (item.label === "Age/Gender" && patientNameField?.include_age_gender) {
                                        return {
                                            ...item,
                                            is_active: false
                                        };
                                    }
                                    if (item.label === "IP Id" || item.print_label === "IP Id") {
                                        return {
                                            ...item,
                                            label: "IP ID",
                                            print_label: "IP ID"
                                        };
                                    }
                                    return item;
                                }) : Attendercard_Layout_Default_JSON.map(item =>
                                    item.label === "Patient Name"
                                        ? { ...item, include_age_gender: false }
                                        : item
                                ),
                            cardWidth: Data?.sticker_setup?.width ? Data?.sticker_setup?.width : 8,
                            cardHeight: Data?.sticker_setup?.height ? Data?.sticker_setup?.height : 5,
                            Label: Data?.label == true || Data?.label == false ? JSON.stringify(Data?.label) : "true",
                            AlignLeft: Data?.content_alignment?.horizontal === "left",
                            AlignCenter: Data?.content_alignment?.horizontal === "center",
                            AlignRight: Data?.content_alignment?.horizontal === "right",
                            AlignTop: Data?.content_alignment?.vertical === "top",
                            AlignMiddle: Data?.content_alignment?.vertical === "middle",
                            AlignBottom: Data?.content_alignment?.vertical === "bottom",
                            Margintop: Data?.margin_setup?.top ? Data?.margin_setup?.top : "0",
                            MarginRight: Data?.margin_setup?.right ? Data?.margin_setup?.right : "0",
                            MarginBottom: Data?.margin_setup?.bottom ? Data?.margin_setup?.bottom : "0",
                            MarginLeft: Data?.margin_setup?.left ? Data?.margin_setup?.left : "0",
                            FontSize: Data?.sticker_setup?.font_size ? Data?.sticker_setup?.font_size : 10,
                            LineSpace: Data?.sticker_setup?.line_spacing ? Data?.sticker_setup?.line_spacing : 5,
                        }, () => {
                            this.getCustomCardPreview()
                        })
                    }
                }).catch((error) => {
                    this.LoaderFunction(false)
                    this.errorMessage(error?.response?.data?.message || error.message)
                })
        } catch (e) {
            this.LoaderFunction(false)
            this.errorMessage(e.message)
        }
    }

    checkValidation = () => {
        let states = this.state;
        let cardDetails = states?.card_detail_data.every(obj => !obj.is_active);
        if (!states?.cardHeight || states?.cardHeight === '') {
            this.errorMessage("Card height is required");
            return false;
        }
        if (!states?.cardWidth || states?.cardWidth === '') {
            this.errorMessage("Card width is required");
            return false;
        }
        if (!states?.FontSize || states?.FontSize === '') {
            this.errorMessage("Font Size is required");
            return false;
        }
        if (!states?.LineSpace || states?.LineSpace === '') {
            this.errorMessage("Line Space is required");
            return false;
        }
        const cardHeightNum = Number(states.cardHeight);
        const cardWidthNum = Number(states.cardWidth);
        const fontSizeNum = Number(states.FontSize);
        const lineSpaceNum = Number(states.LineSpace);
        const marginTopNum = Number(states.Margintop);
        const marginBottomNum = Number(states.MarginBottom);
        const marginLeftNum = Number(states.MarginLeft);
        const marginRightNum = Number(states.MarginRight);

        // Height validation: max 5, min 4
        if (cardHeightNum < 4 || cardHeightNum > 5) {
            this.errorMessage("Card height should be between 4cm and 5cm");
            return false;
        }

        // Width validation: max 8, min 6
        else if (cardWidthNum < 6 || cardWidthNum > 8) {
            this.errorMessage("Card width should be between 6cm and 8cm");
            return false;
        }

        // Font size validation: max 12, min 7
        else if (fontSizeNum < 7 || fontSizeNum > 12) {
            this.errorMessage("Font Size should be between 7 and 12");
            return false;
        }

        // Line space validation: max 10, min 3
        else if (lineSpaceNum < 3 || lineSpaceNum > 10) {
            this.errorMessage("Line Space should be between 3mm and 10mm");
            return false;
        }

        // Margin top validation: max 1, min 0
        else if (marginTopNum < 0 || marginTopNum > 1) {
            this.errorMessage("Margin top should be between 0cm and 1cm");
            return false;
        }

        // Margin bottom validation: max 1, min 0
        else if (marginBottomNum < 0 || marginBottomNum > 1) {
            this.errorMessage("Margin bottom should be between 0cm and 1cm");
            return false;
        }

        // Margin left validation: max 1, min 0
        else if (marginLeftNum < 0 || marginLeftNum > 1) {
            this.errorMessage("Margin left should be between 0cm and 1cm");
            return false;
        }

        // Margin right validation: max 1, min 0
        else if (marginRightNum < 0 || marginRightNum > 1) {
            this.errorMessage("Margin right should be between 0cm and 1cm");
            return false;
        }

        // Card details validation
        else if (cardDetails) {
            this.errorMessage("Attender details shouldn't be empty");
            return false;
        }

        else {
            return true;
        }
    }

    PostCardDetails = () => {
        let states = this.state
        try {
            let validation = this.checkValidation()
            if (validation) {
                this.LoaderFunction(true)
                const updatedCardData = states.card_detail_data.map(item => {
                    if (item.field_name === 'ip_id') {
                        return {
                            ...item,
                            label: "IP ID",
                            print_label: "IP ID"
                        };
                    }
                    return item;
                });
                let data = {
                    "sticker_setup": {
                        "height": Number(states?.cardHeight),
                        "width": Number(states?.cardWidth),
                        "font_size": Number(states?.FontSize),
                        "line_space": Number(states?.LineSpace),
                    },
                    "margin_setup": {
                        "top": Number(states?.Margintop),
                        "bottom": Number(states?.MarginBottom),
                        "left": Number(states?.MarginLeft),
                        "right": Number(states?.MarginRight),
                    },
                    "label": JSON.parse(states?.Label),
                    "content_alignment": {
                        "horizontal": states?.AlignRight ? "right" : states?.AlignLeft ? 'left' : 'center',
                        "vertical": states?.AlignTop ? "top" : states?.AlignBottom ? 'bottom' : "middle",
                    },
                    "attender_details": updatedCardData,
                }
                RestAPIService.create(data, Serviceurls.ATTENDER_CARD_CONFIG)
                    .then((response) => {
                        if (response.data.status === "success") {
                            this.LoaderFunction(false)
                            this.successMessage(response.data.message)
                            this.getCustomCardPreview()
                        }
                    }).catch((error) => {
                        this.LoaderFunction(false)
                        this.errorMessage(error?.response?.data?.message || error.message)
                    })
            }
        } catch (e) {
            this.LoaderFunction(false)
            this.errorMessage(e.message)
        }
    }

    ResetCardDetails = () => {
        try {
            const defaultCheckedFields = ["Attender", "Patient Name", "IP ID"];
            this.setState({
                cardWidth: "8",
                cardHeight: "5",
                Label: "true",
                card_detail_data: JSON.parse(JSON.stringify(Attendercard_Layout_Default_JSON)),
                drag_label: null,
                AlignLeft: true,
                AlignCenter: false,
                AlignRight: false,
                AlignTop: true,
                AlignBottom: false,
                AlignMiddle: false,
                Margintop: "0.5",
                MarginRight: "0.5",
                MarginBottom: "0.5",
                MarginLeft: "0.5",
                FontSize: 10,
                LineSpace: 5,
            })
        } catch (e) {
            this.LoaderFunction(false)
            this.errorMessage(e.message)
        }
    }

    LoaderFunction = (key) => {
        this.setState({
            isLoader: key
        })
    }

    errorMessage = (message) => {
        this.setState({
            isErrorMsg: true,
            isErrorMsgText: message
        })
    }

    successMessage = (message) => {
        this.setState({
            successMsg: true,
            successMsgText: message
        })
    }

    handleDrag = (e) => {
        this.setState({
            drag_label: e.currentTarget.id
        })
    }

    handleDrop = (e) => {
        var states = this.state
        const dragBox = (states.card_detail_data).find((field) => field.label === states.drag_label);
        const dropBox = (states.card_detail_data).find((field) => field.label === e.currentTarget.id);

        const dragBoxID = dragBox.id;
        const dropBoxID = dropBox.id;

        const newBoxState = (states.card_detail_data).map((field) => {
            if (field.label === states.drag_label) {
                return {
                    ...field,
                    id: dropBoxID,
                };
            }
            if (field.label === e.currentTarget.id) {
                return {
                    ...field,
                    id: dragBoxID,
                };
            }
            return field;
        });

        const SortData = newBoxState.sort((a, b) => { return a.id - b.id })

        this.setState({
            card_detail_data: SortData
        })
    }

    handleCheckClick = (e) => {
        var { card_detail_data } = this.state
        const ID = e?.target?.id

        if (ID) {
            const Index = card_detail_data.findIndex((data) => {
                return data.id == ID
            })

            // Check if the field is Age/Gender and should be disabled
            if (card_detail_data[Index].label === "Age/Gender" && this.shouldDisableAgeGender()) {
                e.preventDefault();
                return;
            }

            if (card_detail_data[Index].is_default) {
            } else {
                card_detail_data[Index].is_active = e.target.checked
            }

            this.setState({
                card_detail_data
            })
        } else {
            card_detail_data.forEach((item) => {
                const Index = card_detail_data.findIndex((data) => {
                    return data.id == item.id
                })

                if (item.label === "Age/Gender" && this.shouldDisableAgeGender()) {
                    return;
                }

                if (card_detail_data[Index].is_default) {
                } else {
                    card_detail_data[Index].is_active = true
                }

                this.setState({
                    card_detail_data
                })
            })
        }
    }

    handleIncludeAgeGenderClick = (e, patientNameId) => {
        const { card_detail_data } = this.state;
        const includeAgeGender = e.target.checked;

        const updatedData = card_detail_data.map((item) => {
            if (item.id === patientNameId && item.label === "Patient Name") {
                return {
                    ...item,
                    include_age_gender: includeAgeGender
                };
            }

            if (item.label === "Age/Gender") {
                return {
                    ...item,
                    is_active: includeAgeGender ? false : item.is_active
                };
            }

            return item;
        });

        this.setState({
            card_detail_data: updatedData
        });
    }

    shouldDisableAgeGender = () => {
        const { card_detail_data } = this.state;
        const patientNameField = card_detail_data.find(item => item.label === "Patient Name");
        return patientNameField?.include_age_gender === true;
    }

    renderCardField = (data) => {
        const displayLabel = data.label === "IP Id" ? "IP ID" : data.label;
        return (
            <div
                draggable={data.label !== "Barcode"}
                onDragOver={(e) => e.preventDefault()}
                onDragStart={data.label !== "Barcode" ? this.handleDrag : null}
                onDrop={data.label !== "Barcode" ? this.handleDrop : null}
                id={data.label}
                className="eMed_demolayout_right2_field"
            >
                {data.label !== "Barcode" && (
                    <img className="eMed_demolayout_right2_field_img" src={ImagePaths.DragIndicator.default} alt="Drag Here" />
                )}

                {data.label === "Patient Name" ? (
                    <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    id={data.id}
                                    emed_tid="Patient_Name_CheckBox"
                                    onChange={this.handleCheckClick}
                                    checked={data.is_active}
                                />
                            }
                            label={displayLabel}
                        />
                        <FormControlLabel
                            control={
                                <Checkbox
                                    id={`include_age_gender_${data.id}`}
                                    emed_tid="Include_Age_Gender_CheckBox"
                                    onChange={(e) => this.handleIncludeAgeGenderClick(e, data.id)}
                                    checked={data.include_age_gender || false}
                                    size="small"
                                />
                            }
                            label={
                                <Typography sx={{ fontSize: '0.7vw', color: '#666' }}>
                                    Include Age/Gender
                                </Typography>
                            }
                        />
                    </Box>
                ) : (
                    <FormControlLabel
                        control={
                            <Checkbox
                                id={data.id}
                                emed_tid={`Attender_Details_CheckBox_${data.label}`}
                                onChange={this.handleCheckClick}
                                checked={data.is_active}
                                disabled={data.label === "Age/Gender" && this.shouldDisableAgeGender()}
                            />
                        }
                        label={displayLabel}
                        style={data.label === "Age/Gender" && this.shouldDisableAgeGender() ? { opacity: 0.6 } : {}}
                    />
                )}
            </div>
        )
    }

    onChangeHandler = (e, names, index) => {
        try {
            let value = e.target.value
            let states = this.state
            switch (names) {
                case 'Width':
                    // Width: max 8, min 6
                    if ((CommonValidation.DecimalNumber(value) && value >= 6 && value <= 8) || value === '') {
                        this.setState({ cardWidth: value })
                    }
                    break;
                case 'Height':
                    // Height: max 5, min 4
                    if ((CommonValidation.DecimalNumber(value) && value >= 4 && value <= 5) || value === '') {
                        this.setState({ cardHeight: value })
                    }
                    break;
                case 'Top':
                    // Margin top: max 1, min 0
                    if ((CommonValidation.DecimalNumber(value) && value >= 0 && value <= 1) || value === '') {
                        this.setState({ Margintop: value })
                    }
                    break;
                case 'Bottom':
                    // Margin bottom: max 1, min 0
                    if ((CommonValidation.DecimalNumber(value) && value >= 0 && value <= 1) || value === '') {
                        this.setState({ MarginBottom: value })
                    }
                    break;
                case 'Left':
                    // Margin left: max 1, min 0
                    if ((CommonValidation.DecimalNumber(value) && value >= 0 && value <= 1) || value === '') {
                        this.setState({ MarginLeft: value })
                    }
                    break;
                case 'Right':
                    // Margin right: max 1, min 0
                    if ((CommonValidation.DecimalNumber(value) && value >= 0 && value <= 1) || value === '') {
                        this.setState({ MarginRight: value })
                    }
                    break;
                case 'Font Size':
                    // Font Size: max 12, min 7
                    if (value === '') {
                        this.setState({ FontSize: value });
                    } else if (/^\d*\.?\d*$/.test(value)) {
                        // Limit to 4 characters total (including decimal)
                        if (value.length <= 4) {
                            const numValue = parseFloat(value);
                            if (numValue <= 12) {
                                this.setState({ FontSize: value });
                            } else {
                                this.setState({ FontSize: "12" });
                            }
                        }
                    }
                    break;
                case 'Line Space':
                    // Line Space: max 10, min 3
                    if (value === '') {
                        this.setState({ LineSpace: value });
                    } else if (/^\d*\.?\d*$/.test(value)) {
                        // Limit to 4 characters total (including decimal)
                        if (value.length <= 4) {
                            const numValue = parseFloat(value);
                            if (numValue <= 10) {
                                this.setState({ LineSpace: value });
                            } else {
                                this.setState({ LineSpace: "10" });
                            }
                        }
                    }
                    break;
                default:
                    states[names] = value
                    this.setState({ states })
                    break;
            }
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    renderTextFieldWithTooltip = (name, value, marginLeft, unit = "pt", tooltipText) => {
        return (
            <Box sx={{ marginLeft: marginLeft }}>
                <Typography mb={"0.3vw"} sx={{ fontSize: '0.9vw', fontWeight: '500' }}>{name}</Typography>
                <TextField
                    size='small'
                    sx={{ width: "8vw" }}
                    autoComplete='off'
                    value={value}
                    inputProps={{ style: { fontWeight: '600', fontSize: '0.8vw' } }}
                    onChange={(e) => {
                        this.onChangeHandler(e, name)
                    }}
                    InputProps={{
                        endAdornment: <Typography sx={{ fontSize: '0.8vw' }}>{unit}</Typography>,
                        emed_tid: `Field_${name}`
                    }}
                    helperText={tooltipText}
                    FormHelperTextProps={{
                        sx: { fontSize: '0.7vw', margin: 0 }
                    }}
                />
            </Box>
        )
    }

    renderCardLeft = () => {
        try {
            var states = this.state
            return (
                <Stack component={"div"}>
                    <Paper className='eMed_common_Tbl_right' sx={{ width: "98%", height: "76vh", marginTop: '0vw' }} elevation={2}>
                        <Typography className='eMed_refdoc_title' sx={{ fontSize: '1.2vw', fontWeight: '600', padding: '1vw' }}>
                            {"Card Layout Configuration"}
                        </Typography>
                        <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", height: "68vh", padding: '2vw' }}>
                            {states.previewUrl ?
                                <iframe
                                    style={{
                                        width: "100%",
                                        height: "60%",
                                        border: "1px solid #ddd",
                                        borderRadius: '8px'
                                    }}
                                    src={states.previewUrl}
                                    type="application/pdf" />
                                :
                                <Box sx={{
                                    width: "100%",
                                    height: "60%",
                                    border: "2px dashed #ddd",
                                    borderRadius: '8px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    backgroundColor: '#f9f9f9'
                                }}>
                                    <Typography fontSize={"0.9vw"} color="#666">
                                        No preview available
                                    </Typography>
                                </Box>
                            }
                        </Box>
                    </Paper>
                </Stack>
            )
        } catch (e) {
            this.errorMessage(e.message)
            return null;
        }
    }


    getCustomCardPreview = () => {
        try {
            RestAPIService.getAll(`${Serviceurls.ATTENDER_CARD_PRINT}?preview=true`)
                .then((response) => {
                    const file = new Blob(
                        [response.data],
                        { type: 'application/pdf' });
                    const fileURL = URL.createObjectURL(file);
                    this.setState({
                        previewUrl: fileURL
                    })
                    this.LoaderFunction(false);
                }).catch((e) => {
                    this.errorMessage(e.message)
                    this.LoaderFunction(false);
                })
        }
        catch (e) {
            this.errorMessage(e.message)
            this.LoaderFunction(false);
        }
    }

    renderCardRight = () => {
        try {
            var states = this.state
            return (
                <Stack component={"div"}>
                    <Paper className='eMed_common_Tbl_right' sx={{ overflow: "hidden", height: "76vh", display: 'flex', flexDirection: 'column', marginTop: '0vw' }} elevation={2}>
                        <Typography className='eMed_refdoc_title' sx={{ fontSize: '1.2vw', fontWeight: '600', padding: '1vw', flexShrink: 0 }}>
                            {"Card Layout Configuration"}
                        </Typography>
                        <Box sx={{
                            height: "calc(70vh - 80px)",
                            overflow: "auto",
                            padding: '0 1vw',
                            flexGrow: 1,
                            '&::-webkit-scrollbar': {
                                width: '6px',
                            },
                            '&::-webkit-scrollbar-track': {
                                background: '#f1f1f1',
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb': {
                                background: '#c1c1c1',
                                borderRadius: '10px',
                            },
                            '&::-webkit-scrollbar-thumb:hover': {
                                background: '#a8a8a8',
                            }
                        }}>
                            <Box className="eMed_ipLabel_right_divs">
                                <Typography sx={{ fontWeight: "600" }}>Label Layout Field</Typography>
                                <Typography sx={{ fontSize: "0.8vw" }}>(Switch the fields according to your practice)</Typography>
                            </Box>
                            {/* STICKER SETUP Section */}
                            <Box sx={{ borderBottom: "1px solid #E3E2E2", paddingBottom: '1vw' }}>
                                <Typography sx={{ fontWeight: "600", fontSize: '1vw', marginBottom: '0.5vw' }}>{"Sticker Setup"}</Typography>
                                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "flex-start", marginBottom: '0.5vw' }}>
                                    {this.renderTextFieldWithTooltip(
                                        'Width',
                                        this.state.cardWidth,
                                        "",
                                        "cm",
                                        "6cm - 8cm"
                                    )}
                                    {this.renderTextFieldWithTooltip(
                                        'Height',
                                        this.state.cardHeight,
                                        "1vw",
                                        "cm",
                                        "4cm - 5cm"
                                    )}
                                </Box>
                                <Box sx={{ display: "flex", flexDirection: "row", alignItems: "flex-start" }}>
                                    {this.renderTextFieldWithTooltip(
                                        'Font Size',
                                        this.state.FontSize,
                                        "",
                                        "pt",
                                        "7pt - 12pt"
                                    )}
                                    {this.renderTextFieldWithTooltip(
                                        'Line Space',
                                        this.state.LineSpace,
                                        "1vw",
                                        "mm",
                                        "3mm - 10mm"
                                    )}
                                </Box>
                            </Box>

                            {/* MARGIN SETUP Section */}
                            <Box sx={{ borderBottom: "1px solid #E3E2E2", padding: '1vw 0' }}>
                                <Typography sx={{ fontWeight: "600", fontSize: '1vw', marginBottom: '0.5vw' }}>{"Margin Setup"}</Typography>
                                <Box sx={{ display: "flex", flexDirection: "column", gap: '0.5vw' }}>
                                    <Box sx={{ display: "flex", flexDirection: "row", alignItems: "flex-start", gap: '1vw' }}>
                                        {this.renderTextFieldWithTooltip(
                                            'Top',
                                            this.state.Margintop,
                                            "",
                                            "cm",
                                            "0cm - 1cm"
                                        )}
                                        {this.renderTextFieldWithTooltip(
                                            'Bottom',
                                            this.state.MarginBottom,
                                            "",
                                            "cm",
                                            "0cm - 1cm"
                                        )}
                                    </Box>
                                    <Box sx={{ display: "flex", flexDirection: "row", alignItems: "flex-start", gap: '1vw' }}>
                                        {this.renderTextFieldWithTooltip(
                                            'Left',
                                            this.state.MarginLeft,
                                            "",
                                            "cm",
                                            "0cm - 1cm"
                                        )}
                                        {this.renderTextFieldWithTooltip(
                                            'Right',
                                            this.state.MarginRight,
                                            "",
                                            "cm",
                                            "0cm - 1cm"
                                        )}
                                    </Box>
                                </Box>
                            </Box>

                            {/* ATTENDER DETAILS Section */}
                            <Box sx={{ borderBottom: "1px solid #E3E2E2", padding: '1vw 0' }}>
                                <Typography sx={{ fontWeight: "600", fontSize: '1vw', marginBottom: '0.5vw' }}>{"Attender Details"}</Typography>
                                <Box sx={{
                                    overflow: 'auto',
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '4px',
                                    padding: '0.5vw',
                                    backgroundColor: '#fafafa',
                                    '&::-webkit-scrollbar': {
                                        width: '6px',
                                    },
                                    '&::-webkit-scrollbar-track': {
                                        background: '#f1f1f1',
                                        borderRadius: '10px',
                                    },
                                    '&::-webkit-scrollbar-thumb': {
                                        background: '#c1c1c1',
                                        borderRadius: '10px',
                                    },
                                    '&::-webkit-scrollbar-thumb:hover': {
                                        background: '#a8a8a8',
                                    }
                                }}>
                                    {states.card_detail_data.map((item) => {
                                        return this.renderCardField(item)
                                    })}
                                </Box>
                            </Box>

                            {/* Content Alignment Section */}
                            <Box sx={{ padding: '1vw 0' }}>
                                <Typography sx={{ fontWeight: "600", fontSize: '1vw', marginBottom: '0.5vw' }}>{"Content alignment"}</Typography>
                                <Typography sx={{ fontSize: "0.8vw", color: '#666', marginBottom: '1vw' }}>
                                    {"(Select a click on creating type profiles)"}
                                </Typography>

                                {/* Horizontal Alignment */}
                                <Typography sx={{ fontSize: "0.8vw", fontWeight: '500', marginBottom: '0.5vw' }}>Horizontal:</Typography>
                                <Stack direction="row" spacing={1} alignItems="flex-end" mb={2}>
                                    <Tooltip placement="top" title={"Align Left"}>
                                        <Button
                                            emed_tid={'Left_Align_Button'}
                                            onClick={() => { this.setState({ AlignLeft: true, AlignCenter: false, AlignRight: false }) }}
                                            variant={states?.AlignLeft ? 'contained' : 'outlined'}
                                            size="small"
                                            sx={{ minWidth: 'auto', padding: '0.5vw' }}
                                        >
                                            <img style={{ width: "1.2vw", height: "1.2vw" }} src={states?.AlignLeft ? ImagePaths.AlignLeft.default : ImagePaths.DisAlignLeft.default} alt='Align Left' />
                                        </Button>
                                    </Tooltip>
                                    <Tooltip placement="top" title={"Align Center"}>
                                        <Button
                                            emed_tid={'Center_Align_Button'}
                                            onClick={() => { this.setState({ AlignCenter: true, AlignRight: false, AlignLeft: false }) }}
                                            variant={states?.AlignCenter ? 'contained' : 'outlined'}
                                            size="small"
                                            sx={{ minWidth: 'auto', padding: '0.5vw' }}
                                        >
                                            <img style={{ width: "1.2vw", height: "1.2vw" }} src={states?.AlignCenter ? ImagePaths.AlignCenter.default : ImagePaths.DisAlignCenter.default} alt='Align Center' />
                                        </Button>
                                    </Tooltip>
                                    <Tooltip placement="top" title={"Align Right"}>
                                        <Button
                                            emed_tid={'Right_Align_Button'}
                                            onClick={() => { this.setState({ AlignRight: true, AlignLeft: false, AlignCenter: false }) }}
                                            variant={states?.AlignRight ? 'contained' : 'outlined'}
                                            size="small"
                                            sx={{ minWidth: 'auto', padding: '0.5vw' }}
                                        >
                                            <img style={{ width: "1.2vw", height: "1.2vw" }} src={states?.AlignRight ? ImagePaths.AlignRight.default : ImagePaths.DisAlignRight.default} alt='Align Right' />
                                        </Button>
                                    </Tooltip>
                                </Stack>

                                {/* Vertical Alignment */}
                                <Typography sx={{ fontSize: "0.8vw", fontWeight: '500', marginBottom: '0.5vw' }}>Vertical:</Typography>
                                <Stack direction="row" spacing={1} alignItems="flex-end">
                                    <Tooltip placement="top" title={"Align Top"}>
                                        <Button
                                            emed_tid={'Top_Align_Button'}
                                            onClick={() => { this.setState({ AlignTop: true, AlignMiddle: false, AlignBottom: false }) }}
                                            variant={states?.AlignTop ? 'contained' : 'outlined'}
                                            size="small"
                                            sx={{ minWidth: 'auto', padding: '0.5vw' }}
                                        >
                                            <img style={{ width: "1.2vw", height: "1.2vw" }} src={states?.AlignTop ? ImagePaths.AlignTop.default : ImagePaths.DisAlignTop.default} alt='Align Top' />
                                        </Button>
                                    </Tooltip>
                                    <Tooltip placement="top" title={"Align Middle"}>
                                        <Button
                                            emed_tid={'Middle_Align_Button'}
                                            onClick={() => { this.setState({ AlignMiddle: true, AlignTop: false, AlignBottom: false }) }}
                                            variant={states?.AlignMiddle ? 'contained' : 'outlined'}
                                            size="small"
                                            sx={{ minWidth: 'auto', padding: '0.5vw' }}
                                        >
                                            <img style={{ width: "1.2vw", height: "1.2vw" }} src={states?.AlignMiddle ? ImagePaths.AlignMiddle.default : ImagePaths.DisAlignMiddle.default} alt='Align Middle' />
                                        </Button>
                                    </Tooltip>
                                    <Tooltip placement="top" title={"Align Bottom"}>
                                        <Button
                                            emed_tid={'Bottom_Align_Button'}
                                            onClick={() => { this.setState({ AlignBottom: true, AlignTop: false, AlignMiddle: false }) }}
                                            variant={states?.AlignBottom ? 'contained' : 'outlined'}
                                            size="small"
                                            sx={{ minWidth: 'auto', padding: '0.5vw' }}
                                        >
                                            <img style={{ width: "1.2vw", height: "1.2vw" }} src={states?.AlignBottom ? ImagePaths.AlignBottom.default : ImagePaths.DisAlignBottom.default} alt='Align Bottom' />
                                        </Button>
                                    </Tooltip>
                                </Stack>
                            </Box>
                        </Box>

                        {/* Buttons */}
                        <Stack spacing={2} direction="row" sx={{
                            backgroundColor: Colors.DataTblHeaderbg,
                            padding: '1vw',
                            height: '9vh',
                            flexShrink: 0
                        }} alignItems="center" justifyContent="center">
                            <Button emed_tid={'Reset_Button'} disabled={states?.isLoader} variant='outlined' size="small" onClick={() => { this.ResetCardDetails() }}>{"Reset"}</Button>
                            <Button emed_tid={'Post_Button'} disabled={states?.isLoader} variant='contained' size="small" onClick={() => { this.PostCardDetails() }}>{"Save"}</Button>
                        </Stack>
                    </Paper>
                </Stack>
            )
        } catch (error) {
            this.errorMessage(error.message)
        }
    }

    msgClose() {
        this.setState({
            isErrorMsg: false,
            isErrorMsgText: '',
            successMsg: false,
            successMsgText: ''
        })
    }

    render() {
        try {
            return (
                <Box component={'div'} className='eMed_usrconf_container' sx={{ marginTop: "1dvw" }}>
                    <Grid container className='eMed_refdoc_content' spacing={2}>
                        <Grid item xs={7.5}>
                            {this.renderCardLeft()}
                        </Grid>
                        <Grid item xs={4.5}>
                            {this.renderCardRight()}
                        </Grid>
                    </Grid>
                    {this.state.isErrorMsg ?
                        <ToastMsg
                            severity={'error'}
                            msg={this.state.isErrorMsgText}
                            msgPop={this.msgClose.bind(this)}
                        />
                        : null}
                    {this.state.successMsg ?
                        <ToastMsg
                            severity={'success'}
                            msg={this.state.successMsgText}
                            msgPop={this.msgClose.bind(this)}
                        />
                        : null}
                    <Loader loaderOpen={this.state.isLoader} />
                </Box>
            )
        } catch (e) {
            this.errorMessage(e.message)
        }
    }
}

export default AttendercardLayoutConfig;